import React from 'react';
import { ContextMenuRender, getContextMenuConfig } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ContextMenuStoreValue<R = any> {
  ContextMenuRender?: ContextMenuRender<R>;
  getContextMenuConfig?: getContextMenuConfig<R>;
  onAddRows?: (rows: R[]) => void;
  onDeleteRow?: (row?: R) => void;
  onRowReorder?: (sourceRowIndex: number, targetRowIndex: number) => void;
  enableAddAction?: boolean;
  enableRowRecord?: boolean;
  enableRowTools?: boolean;
  readonly?: boolean;
}

export const ContextMenuStore = React.createContext<ContextMenuStoreValue>({
  ContextMenuRender: undefined,
  getContextMenuConfig: undefined,
});
